module.exports = __webpack_public_path__ + "static/media/bubble-notif.1bd4172c.mp3";